module.exports = __webpack_public_path__ + "static/taggieletterboxmain-d885cb7f1e82637e674f3a0274e9442c.png";